import React from 'react';
import { Col, ModalV2, Row, Spinner2, Text } from 'components';
import { Avatar } from 'components/Tailwindcss';
import { theme } from 'lib';
import {
  AvatarWrapper,
  ReactionEmoji,
  ReactionEmojiOverlay,
  ReactionFilterButton,
  ReactionsFilterSection,
  ReactionsListSection,
  ReactionsModalContent,
  ReactionUserItem,
  UserInfoWrapper,
  UserName,
  UserUsername
} from '../styles';
import { REACTIONS } from '../constants';

const ReactionsModal = ({
  visible,
  onClose,
  reactionsData,
  loadingReactions,
  selectedReactionType,
  onViewReactions,
  currentCommentId
}) => {
  return (
    <ModalV2
      visible={visible}
      closeModal={onClose}
      width="500px"
      header={
        <Row start centerAll>
          <Text h3 bold style={{ fontSize: '20px', fontWeight: '700', lineHeight: '24px' }}>
            Reactions
          </Text>
          {reactionsData?.total > 0 && (
            <Text
              style={{
                fontSize: '15px',
                fontWeight: '400',
                color: theme.GREY_60,
                marginLeft: '8px'
              }}
            >
              ({reactionsData.total})
            </Text>
          )}
        </Row>
      }
    >
      <ReactionsModalContent>
        {/* Reaction Type Filters */}
        {reactionsData?.counts && (
          <ReactionsFilterSection>
            <ReactionFilterButton
              active={!selectedReactionType}
              onClick={() => {
                if (currentCommentId) {
                  onViewReactions(currentCommentId);
                }
              }}
            >
              All ({reactionsData.total || 0})
            </ReactionFilterButton>
            {Object.entries(reactionsData.counts)
              .filter(([_, count]) => count > 0)
              .map(([reactionType, count]) => (
                <ReactionFilterButton
                  key={reactionType}
                  active={selectedReactionType === reactionType}
                  onClick={() => {
                    if (currentCommentId) {
                      onViewReactions(currentCommentId, reactionType);
                    }
                  }}
                >
                  <ReactionEmoji>{REACTIONS[reactionType]}</ReactionEmoji>
                  {reactionType} ({count})
                </ReactionFilterButton>
              ))}
          </ReactionsFilterSection>
        )}

        {/* Reactions List */}
        <ReactionsListSection>
          {loadingReactions ? (
            <Col center pad="60px 0">
              <Spinner2 />
            </Col>
          ) : !reactionsData?.reactions || reactionsData.reactions.length === 0 ? (
            <Col center pad="60px 0">
              <Text
                center
                style={{
                  fontSize: '15px',
                  color: theme.GREY_60,
                  fontWeight: '400'
                }}
              >
                {selectedReactionType
                  ? `No ${selectedReactionType} reactions yet`
                  : 'No reactions yet'}
              </Text>
            </Col>
          ) : (
            reactionsData.reactions.map((reaction, index) => (
              <ReactionUserItem key={reaction._id || index}>
                <AvatarWrapper>
                  <Avatar src={reaction.user?.avatar} size={40}>
                    {reaction.user?.name}
                  </Avatar>
                  <ReactionEmojiOverlay>{REACTIONS[reaction.reaction]}</ReactionEmojiOverlay>
                </AvatarWrapper>
                <UserInfoWrapper>
                  <UserName>
                    {reaction.user?.name || reaction.user?.username || 'Unknown User'}
                  </UserName>
                  {reaction.user?.username && (
                    <UserUsername>@{reaction.user.username}</UserUsername>
                  )}
                </UserInfoWrapper>
              </ReactionUserItem>
            ))
          )}
        </ReactionsListSection>
      </ReactionsModalContent>
    </ModalV2>
  );
};

export default ReactionsModal;
